import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const handleAuth = async () => {
      const hash = location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (sessionId) {
        try {
          // Exchange session_id for session_token
          const authBackendUrl = process.env.REACT_APP_AUTH_BACKEND_URL;
          if (!authBackendUrl) {
            console.error('REACT_APP_AUTH_BACKEND_URL not configured');
            navigate('/', { replace: true });
            return;
          }
          
          const response = await fetch(`${authBackendUrl}/auth/v1/env/oauth/session-data`, {
            headers: {
              'X-Session-ID': sessionId
            }
          });

          if (response.ok) {
            const data = await response.json();
            
            // Send session_token to backend to create session
            await authAPI.createSession(data.session_token, {
              id: data.id,
              email: data.email,
              name: data.name,
              picture: data.picture
            });

            // Refresh auth state
            await checkAuth();

            // Clean URL and redirect
            window.history.replaceState({}, document.title, '/dashboard');
            navigate('/dashboard', { replace: true });
          }
        } catch (error) {
          console.error('Auth error:', error);
          navigate('/', { replace: true });
        }
      } else {
        navigate('/', { replace: true });
      }
    };

    handleAuth();
  }, [location, navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-red-600 mx-auto mb-4" />
        <p className="text-gray-600">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
